<template>
  <fluke-login-box title="Recuperar senha">
    <div slot="content">
        <div class="check" v-if="checkFails">Usuário inválido</div>
        <div class="check" v-if="serverFails">Falha no serviço, tente mais tarde.</div>
        <div class="success" v-if="success">Você receberá um e-mail em instantes para criar uma nova senha.</div>
        <div class="box-input">
            <label for="usuario">Usuário:</label>
            <input
            id="usuario"
            type="text"
            v-model="user"
            v-on:keyup.enter="passwordRecovery" /><br>
        </div>
        <button v-on:click="passwordRecovery">ENVIAR</button>
    </div>
    <div slot="links">
        <router-link to="/login">
            Voltar para login
        </router-link>
    </div>
  </fluke-login-box>
</template>

<script>
import axios from 'axios'
import LoginBox from '../components/Main/Content/LoginBox/LoginBox'

export default {
    components: {
        'fluke-login-box': LoginBox,
    },
    data () {
        return {
            user: '',
            checkFails: false,
            serverFails: false,
            success: false,
        }
    },
    methods: {
        async passwordRecovery()
        {
            this.success = false
            this.checkFails = false
            this.serverFails = false
            var response = '';
            try {
                response = await axios.put(
                    this.$myServerAddresses.admin + 'users/password-recovery',
                    {
                        user: this.user,
                    }
                )
                if ( response.data.success == false) {
                    this.checkFails = true;
                    return;
                }
                this.success = true
            } catch(e) {
                this.serverFails = true;
                console.log(e);
                return;
            }
        }
    }
}
</script>
